import { render } from "./adminuser.vue?vue&type=template&id=28fc71b2"
import script from "./adminuser.vue?vue&type=script&lang=ts"
export * from "./adminuser.vue?vue&type=script&lang=ts"
script.render = render

export default script